import { OPERATOR_NAMES } from '@entities/operator/model/constants';
import { WEB_ORANGE_MOROCCO } from '@shared/config/constants/api-sources';

export const isMAUmobileSLA = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.MalaysiaUmobileSLA.toUpperCase();

export const isBHZainSLA = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.BahrainZainSLA.toUpperCase();

export const isVirgin = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.Virgin.toUpperCase();

export const isKorek = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.IraqKorek.toUpperCase();

export const isSTC = (operator) => operator?.toUpperCase() === OPERATOR_NAMES.STC.toUpperCase();

export const isKuwaitSTC = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.KuwaitSTC.toUpperCase();

export const isKSARedbull = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.KSA_REDBULL.toUpperCase();

export const isIQFastLink = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.IraqFastLink.toUpperCase();

export const isKuwaitZainIdex = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.KuwaitZainIdex.toUpperCase();

export const isKSAMobily = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.KSA_MOBILY.toUpperCase();

export const isMarocDVFlow = (operator) =>
  [OPERATOR_NAMES.MarocTelecom, OPERATOR_NAMES.MarocInwi, OPERATOR_NAMES.MarocOrange].includes(
    operator
  );

export const isMarocOrange = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.MarocOrange.toUpperCase();

export const isMoroccoDvContext = (...values: Array<string | undefined | null>) =>
  values.some((value) => value === WEB_ORANGE_MOROCCO || isMarocDVFlow(value));

export const isEvinaDU = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.DuEvina.toUpperCase();

export const isLibyaFlow = (operator) =>
  [OPERATOR_NAMES.LibyaMadar, OPERATOR_NAMES.LibyaLibyana].includes(operator);

export const isKSAVirgin = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.KSA_Virgin.toUpperCase();

export const isIraqAsiacell = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.IraqAsiaCell.toUpperCase();

export const isTunisiaOrange = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.TunisiaOrange.toUpperCase();

export const isIraqZain = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.IraqZain.toUpperCase();

export const isPortugalVodafone = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.PortugalVodafone.toUpperCase();

export const isPortugalMeo = (operator) =>
  operator?.toUpperCase() === OPERATOR_NAMES.PortugalMeo.toUpperCase();
